(function () {

    'use strict';

    angular.module('asys')
        .component('asysErgebnisAltvertrag', {
            bindings: {
                altvertrag: '<aeaAltvertrag',
                beitraegeAltvertrag: '<aeaBeitraegeAltvertrag',
                changeZahlweise: '&?aeaChangeZahlweise',
                options: '<aeaOptions'
            },
            templateUrl: 'ergebnis/partials/ergebnisAltvertrag.html',
            controller: ErgebnisAltvertragController,
            controllerAs: 'ergAltvertragVm'
        });

    ErgebnisAltvertragController.$inject = [
        '$analytics',
        'lodash',
        'AppConfig',
        'SchluesselWerteUtilsService'
    ];
    function ErgebnisAltvertragController($analytics, _, AppConfig, SchluesselWerteUtilsService) {
        var vm = this,
            zahlweisen = AppConfig.ANGEBOT.zahlweisen,
            objekte;

        vm.$onInit = onInit;
        vm.$onChanges = onChanges;

        vm.onOpen = onOpen;
        vm.onClose = onClose;

        function activate() {
            objekte = _.get(vm.altvertrag, 'objekte[0]');

            vm.options = vm.options || {};
            vm.gridLayoutCss = vm.options.grid || {};

            vm.zahlweise = vm.zahlweise ? vm.zahlweise : _.get(objekte, 'zahlweise');
            vm.moeglicheZahlweisen = _.uniqBy([
                SchluesselWerteUtilsService.create('ZAHLWEISE', zahlweisen.JAEHRLICH.wert, zahlweisen.JAEHRLICH.bezeichnung),
                _.get(objekte, 'zahlweise')
            ], 'wert');
            vm.gesamtbeitrag = getGesamtbeitragZuZahlweise();
            vm.title = getTitle();

            if (!vm.gridLayoutCss.columnLeft) {
                vm.gridLayoutCss.columnLeft = 'small-6';
            }

            if (!vm.gridLayoutCss.columnRight) {
                vm.gridLayoutCss.columnRight = 'small-6';
            }
        }

        function onInit() {
            vm.isOpen = vm.options.isOpen || undefined;
            activate();
        }

        function onChanges() {
            activate();
        }
        function getGesamtbeitragZuZahlweise() {
            if (_.get(vm.zahlweise, 'wert') === zahlweisen.JAEHRLICH.wert && !_.get(objekte, 'saisonKennzeichen', false)) {
                return _.get(objekte, 'jahresbeitrag');
            } else {
                return _.get(objekte, 'praemie');
            }
        }
        function getTitle() {
            var title = 'Ihr bisheriger Beitrag';

            switch (_.get(vm.zahlweise, 'wert')) {
            case '51':
                title = 'Ihr bisheriger Jahresbeitrag';
                break;
            case '50':
                title = 'Ihr bisheriger Halbjahresbeitrag';
                break;
            case '49':
                title = 'Ihr bisheriger Quartalsbeitrag';
                break;
            case '48':
                title = 'Ihr bisheriger Monatsbeitrag';
                break;
            case '47':
                title = 'Ihr bisheriger Einmalbeitrag';
                break;
            }

            return title;
        }

        function onOpen() {
            if (vm.isOpen !== undefined) {
                $analytics.eventTrack('accordion', {
                    trackingProvider: 'wgv',
                    target: 'altvertrag',
                    value: 'open'
                });
            }
        }

        function onClose() {
            if (vm.isOpen !== undefined) {
                $analytics.eventTrack('accordion', {
                    trackingProvider: 'wgv',
                    target: 'altvertrag',
                    value: 'close'
                });
            }
        }

    }
})();
